export default __webpack_public_path__ + "static/cc-banner-image-ad84f419704edf76d256d5396428237d.webp";